import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

/////////////////////////////////////////////////////////////////////
// load

export const BLOGS_SHORT_MESSAGE_DETAIL_FETCH_TRIGGER = "BLOGS_SHORT_MESSAGE_DETAIL_FETCH_TRIGGER";
export interface BlogsShortMessageDetailFetchTriggerAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_DETAIL_FETCH_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export const BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST = "BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST";
export interface BlogsShortMessageDetailFetchRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export interface BlogsShortMessageDetailFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
        comments: number[];
        complaints: number[];
    };
}
export const BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS = "BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS";
export interface BlogsShortMessageDetailFetchSuccessAction extends APISuccessAction<BlogsShortMessageDetailFetchNormalizedResponse> {
    readonly type: typeof BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export const BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE = "BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE";
export interface BlogsShortMessageDetailFetchFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}

export const blogsShortMessageDetailFetchTrigger = (
    username: string,
    postSlug: string,
    accessKey: string,
): BlogsShortMessageDetailFetchTriggerAction => ({
    type: BLOGS_SHORT_MESSAGE_DETAIL_FETCH_TRIGGER,
    username,
    postSlug,
    accessKey,
});
export const blogsShortMessageDetailFetchApi = {
    request: (
        username: string,
        postSlug: string,
        accessKey: string,
    ): BlogsShortMessageDetailFetchRequestAction => ({
        type: BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST,
        username,
        postSlug,
        accessKey,
    }),
    success: (
        username: string,
        postSlug: string,
        accessKey: string,
        response: BlogsShortMessageDetailFetchNormalizedResponse,
    ): BlogsShortMessageDetailFetchSuccessAction => ({
        type: BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS,
        username,
        postSlug,
        accessKey,
        response,
    }),
    failure: (
        username: string,
        postSlug: string,
        accessKey: string,
        error: any,
    ): BlogsShortMessageDetailFetchFailureAction => ({
        type: BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE,
        username,
        postSlug,
        accessKey,
        error,
    }),
};
